import { Injectable, NgModuleRef, inject } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class ICmsAdminUtilAbstractService {
    protected readonly subscriptions = new Subscription();

    protected ngModuleRef = inject(NgModuleRef<any>);

    constructor() {
        this.ngModuleRef.onDestroy(() => {
            try {
                this.subscriptions.unsubscribe();
                this.destroy();
            } catch (err) {
                console.error(err);
            }
        });
    }

    protected destroy() {}
}
